import type { TodoItem } from './types';

/** One entry of "Podsumowanie" as `GET /api/todo/summary` gives it; a moved one has `snoozedUntil`. */
export type SummaryEntry = TodoItem & { snoozedUntil?: string };
/** `archived` / `archivedCount`: „Archiwizuj” (owner 2026-11-03), in no other list or count. */
export type SummarySection = { id: string; title: string; items: SummaryEntry[]; snoozed: SummaryEntry[]; archived?: SummaryEntry[] };
export type SummaryView = { sections: SummarySection[]; count: number; snoozedCount: number; archivedCount?: number };

/** „Archiwizuj zaznaczone”: at most this many at once (as the server checks). */
export const MAX_ARCHIVE = 500;

/** „Archiwizuj zaznaczone”: the ticked entries that are on the screen; `tooMany` above `MAX_ARCHIVE` (the button waits). */
export function archiveBatch(picked: ReadonlySet<string>, shown: ReadonlySet<string>): { ids: string[]; tooMany: boolean } {
  const ids = [...picked].filter((id) => shown.has(id));
  return { ids, tooMany: ids.length > MAX_ARCHIVE };
}

export const SUMMARY_KEY = ['todo', 'summary'] as const;
export const DIGEST_KEY = ['todo', 'daily-summary'] as const;

/** 'YYYY-MM-DD' plus `n` days (calendar arithmetic). */
export function plusDays(day: string, n: number): string {
  const d = new Date(`${day}T00:00:00Z`);
  d.setUTCDate(d.getUTCDate() + n);
  return d.toISOString().slice(0, 10);
}

/** 'YYYY-MM-DD' → '12.11.2026'. */
export const dayText = (day: string) => `${Number(day.slice(8, 10))}.${day.slice(5, 7)}.${day.slice(0, 4)}`;

/** „Przesuń”: na jutro, za tydzień (the day the entry comes back), counted from `today` (Warsaw). */
export const snoozeChoices = (today: string) => [
  { label: 'Na jutro', day: plusDays(today, 1) },
  { label: 'Za tydzień', day: plusDays(today, 7) },
];

/** A bell entry of "Powiadomienia": its message id (opening it marks it read). */
export const notificationId = (entry: Pick<TodoItem, 'id' | 'module'>): string | null => (entry.module === 'notifications' ? (entry.id.split(':')[2] ?? null) : null);
